import AbstractShape from "@/Models/Shapes/AbstractShape";
import { InterfaceModelDecorator } from "./PreviewModelDecorator";
import { IModel } from "makerjs";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";
import { chainModel, filletModel } from "@/functions/makerjs";
import Length from "../../../../source/js/shared/models/Geometry/Length";

export default class ShapeModelDecorator implements InterfaceModelDecorator {
	constructor(
		private parentDecorator: InterfaceModelDecorator | null,
		private baseShapeInstance: AbstractShape
	) {}

	getModel(): IModel {
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		const shapeModel = makerjs.cloneObject(this.baseShapeInstance.render());
		if(shapeModel === undefined) {
			return model;
		}

		if (this.baseShapeInstance.shape !== "dxf") {
			makerjs.model.scale(shapeModel, 10, true); // Convert shapeModel to mm
		}

		makerjs.model.addModel(model, { models: { baseModel: shapeModel } }, "shapeModel");
		return model;
	}
}

export class ShapeModelCombineDecorator implements InterfaceModelDecorator {
	private cachedModel: IModel;
	constructor(
		private parentDecorator: InterfaceModelDecorator | null
	) {}

	getModel(): IModel {
		if (this.cachedModel) {
			return makerjs.cloneObject(this.cachedModel);
		}
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		let combinedModel = makerjs.model.combineSubtraction(
			model.models.shapeModel,
			makerjs.model.combineUnion( model.models.cutoutModel, model.models.drillHoleModel )
		);

		combinedModel = chainModel({
			models: {
				shapeModel: combinedModel.models.a,
				cutoutModel: combinedModel.models.b,
			}
		});
		combinedModel.layer = "shape";

		this.cachedModel = combinedModel;
		return makerjs.cloneObject(combinedModel);
	}
}

export class FilletModelDecorator implements InterfaceModelDecorator {
	private cachedModel: IModel;

	constructor(
		private parentDecorator: InterfaceModelDecorator | null,
		private fillet: Length,
		private reverse: boolean = false
	) {}

	getModel(): IModel {
		if (this.cachedModel) {
			return makerjs.cloneObject(this.cachedModel);
		}
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		model = filletModel(model, this.fillet, this.reverse);
		this.cachedModel = model;
		return makerjs.cloneObject(model);
	}
}

export class CurrentCutoutFilletModelDecorator implements InterfaceModelDecorator {
	constructor(
		private parentDecorator: InterfaceModelDecorator | null,
		private fillet: Length,
		private reverse: boolean = false
	) {}

	getModel(): IModel {
		let model = { models: {} } as IModel;

		if (this.parentDecorator) {
			model = this.parentDecorator.getModel();
		}

		if ( typeof model.models.shapeModel === 'undefined' ) {
			return model;
		}

		model.models.shapeModel.models.baseModel = filletModel(model.models.shapeModel.models.baseModel, this.fillet, this.reverse);

		return model;
	}
}
